import { render, staticRenderFns } from "./ivyPlayer.vue?vue&type=template&id=3ce3b526&scoped=true&"
import script from "./ivyPlayer.vue?vue&type=script&lang=js&"
export * from "./ivyPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ivyPlayer.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ivyPlayer.vue?vue&type=style&index=1&id=3ce3b526&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce3b526",
  null
  
)

export default component.exports